import { cn } from 'utils/cn.tsx';
import type { CategoryData } from 'service/category/model.ts';
import { CHAR } from 'utils/characters.ts';
import { useCallback } from 'preact/hooks';
import noop from 'lodash/noop';
import { getCategoryImage } from 'utils/categoryIdToImagePath.ts';
import { CategoryItemImage } from 'components/modal/categories/CategoryItemImage.tsx';
import { number } from 'utils/format';

export type Props = {
	category: CategoryData;
	className?: string;
	onClick?: (category: CategoryData) => void;
};

export function CategorySearchResult({ category, className, onClick = noop }: Props) {
	const categoryImage = getCategoryImage(category.id);
	const handleClick = useCallback(() => {
		onClick(category);
	}, [category]);

	return (
		<div
			class={cn(
				'flex items-center bg-gray-category rounded-2xl px-3 py-2 text-sm font-medium hover:bg-neutral-10 h-full',
				className,
			)}
			onClick={handleClick}
		>
			<CategoryItemImage categoryImage={categoryImage} categoryName={category.name} />
			<div class="flex flex-col flex-grow flex-shrink">
				<div class="flex items-center">
					<span class="mr-3">{category.name}</span>
				</div>
				<span class="text-xs text-dark-blue-50">
					{category.path?.map((pathFragment) => pathFragment.name).join(`${CHAR.NBSP}> `)}
				</span>
			</div>
			<span class="text-xs text-dark-blue-50 shrink-0">{number(category.offersCount)}</span>
		</div>
	);
}
